import { Component, Host, Prop, h } from '@stencil/core'

export type ProgressionIndicatorSize = 'small' | 'medium' | 'large'

// Discrimination types is not working well with component classes.
// The conditional use of props should be handled by throwing error manually depending on the `format` prop.
// However we can still use union types in each component props

export interface ProgressionBarTypes {
  format: 'bar'
  label: string
  hiddenLabel?: boolean
  description?: string
  progression?: number
  size?: ProgressionIndicatorSize
  total?: never
  current?: never
}

export interface ProgressionFractionsTypes {
  format: 'fractions'
  label: string
  hiddenLabel?: boolean
  description?: string
  total?: 3 | 4 | 5 | 6 | 7 | 8 | 9
  current?: number
  size?: ProgressionIndicatorSize
  progression?: never
}

export type ProgressionIndicatorTypes = ProgressionBarTypes | ProgressionFractionsTypes

let id = 0

@Component({
  tag: 'cobalt-progress-indicator',
  styleUrl: 'cobalt-progress-indicator.css'
})
export class CobaltProgressIndicator {
  progressindicatorId = `progress-indicator-${++id}`
  /**
   * Format of the progress indicator.
   */
  @Prop() format?: ProgressionIndicatorTypes['format'] = 'bar'
  /**
   * Label of the progress indicator.
   */
  @Prop() label!: ProgressionIndicatorTypes['label']
  /**
   * Hide the label from the top of the progress indicator.
   */
  @Prop() hiddenLabel?: ProgressionIndicatorTypes['hiddenLabel'] = false
  /**
   * Description of the progress indicator.
   */
  @Prop() description?: ProgressionIndicatorTypes['description']
  /**
   * The progression value in the `bar` format.
   * It is a percentage representation so it should be from 0 to 100.
   */
  @Prop() progression?: ProgressionIndicatorTypes['progression']
  /**
   * The number of step in the `fractions` format.
   * The minimum of step should be 3 and the maximum should be 9.
   */
  @Prop() total?: ProgressionIndicatorTypes['total']
  /**
   * The current step number in the `fractions` format.
   */
  @Prop() current?: ProgressionIndicatorTypes['current']
  /**
   * The size of the progress indicator.
   */
  @Prop() size?: ProgressionIndicatorTypes['size'] = 'medium'

  render(): any {
    return (
      <Host class="cobalt-progress-indicator">
        <core-progress-indicator
          format={this.format}
          label={this.label}
          description={this.description}
          progression={this.progression}
          size={this.size}
          hiddenLabel={this.hiddenLabel}
          total={this.total}
          current={this.current}
        ></core-progress-indicator>
      </Host>
    )
  }
}
